<script lang="ts" setup>
import { version } from '@/version'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const openDeveloper = (username: string) => {
  window.open(`https://t.me/${username}`, '_blank')
}
</script>

<template>
  <div class="bottom-bar__footer w-100">
    <v-menu location="top">
      <template #activator="{ props }">
        <div v-bind="props" class="cursor-pointer">{{ t('footer.development') }}</div>
      </template>
      <v-list density="compact">
        <v-list-item
          :title="t('footer.frontend')"
          @click="openDeveloper('albugankov')"
        />
        <v-list-item
          :title="t('footer.backend')"
          @click="openDeveloper('iivanov_work')"
        />
      </v-list>
    </v-menu>

    <LanguageSwitcher />

    <div>v {{ version }}</div>
  </div>
</template>

<style scoped>
.bottom-bar__footer {
  margin-top: auto !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  font-size: 12px;
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  border-top: thin solid rgba(var(--v-border-color), calc(var(--v-border-opacity) * 0.5));
  width: 100%;
  max-width: var(--app-max-width);
  margin-left: auto;
  margin-right: auto;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
